import type { IconProps } from './types';

export const UserSettingsIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M19.1458 14.1197L18.5886 12.9287H16.5073L15.9503 14.1207L15.3293 14.4793L14.0184 14.3664L12.9778 16.1687L13.7319 17.2479V17.9636L12.9782 19.043L14.0188 20.8453L15.33 20.7318L15.9504 21.0899L16.5073 22.282H18.5886L19.1461 21.0908L19.768 20.7317L21.0779 20.8453L22.1185 19.043L21.3661 17.9651L21.366 17.2458L22.119 16.1687L21.0784 14.3664L19.7682 14.4791L19.1458 14.1197Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M17.5496 16.6008V18.4758" stroke={color} strokeWidth="1.5" />
      <path
        d="M1.6875 18.5609V14.6116C1.6875 14.6116 4.1875 12.4688 9.1875 12.4688C10.0417 12.4688 10.823 12.5313 11.5312 12.635"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M5.43843 5.43656C5.43843 5.9289 5.5354 6.41641 5.72381 6.87127C5.91222 7.32612 6.18837 7.73942 6.53651 8.08755C6.88464 8.43568 7.29793 8.71184 7.75279 8.90024C8.20765 9.08865 8.69516 9.18563 9.18749 9.18563C9.67983 9.18563 10.1673 9.08865 10.6222 8.90024C11.0771 8.71184 11.4903 8.43568 11.8385 8.08755C12.1866 7.73942 12.4628 7.32612 12.6512 6.87127C12.8396 6.41641 12.9366 5.9289 12.9366 5.43656C12.9366 4.44225 12.5416 3.48866 11.8385 2.78557C11.1354 2.08249 10.1818 1.6875 9.18749 1.6875C8.19318 1.6875 7.23959 2.08249 6.53651 2.78557C5.83342 3.48866 5.43843 4.44225 5.43843 5.43656Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
